export * from './domain';
export * from './builders';
export * from './contact-settings-builder';
export * from './chatbot-poc';
// tslint:disable-next-line:max-line-length
import { WidgetContactType } from './domain';
import { createChatbotPocApi } from './chatbot-poc';
export var createWidgetSettingsApi = function (baseUrl, http) {
    var apiUrl = baseUrl + '/widgets';
    var widgetUrl = function (widgetId) { return "".concat(apiUrl, "/").concat(widgetId); };
    var widgetSettingsUrl = function (widgetId) { return "".concat(apiUrl, "/").concat(widgetId, "/new-settings"); };
    var widgetContentUrl = function (widgetId, locale) { return "".concat(widgetSettingsUrl(widgetId), "/content/").concat(locale); };
    var featuredArticlesUrl = function (widgetId, locale) { return "".concat(widgetContentUrl(widgetId, locale), "/modules/featuredArticles"); };
    var chatModuleUrl = function (widgetId, locale) { return "".concat(widgetContentUrl(widgetId, locale), "/contacts/channel/chat"); };
    var contactFormModuleUrl = function (widgetId, locale) { return "".concat(widgetContentUrl(widgetId, locale), "/contacts/channel/form"); };
    var phoneModuleUrl = function (widgetId, locale) { return "".concat(widgetContentUrl(widgetId, locale), "/contacts/channel/callback"); };
    return {
        getAll: function () { return http.get("".concat(apiUrl, "/list")); },
        getAllWidgatsMap: function () { return http.get("".concat(apiUrl, "/mapping")); },
        rename: function (dto) { return http.put("".concat(widgetUrl(dto.id), "/rename"), { name: dto.name }); },
        delete: function (dto) { return http.delete("".concat(widgetUrl(dto.id)), dto); },
        create: function (dto) { return http.post("".concat(apiUrl, "/add"), dto); },
        enable: function (dto) { return http.post("".concat(widgetSettingsUrl(dto.id), "/enable"), {}); },
        disable: function (dto) { return http.post("".concat(widgetSettingsUrl(dto.id), "/disable"), {}); },
        getDesign: function (dto) { return http.get("".concat(widgetSettingsUrl(dto.id), "/appearance")); },
        setDesign: function (dto) { return http.put("".concat(widgetSettingsUrl(dto.id), "/appearance"), {
            settings: dto.settings
        }); },
        getAdvanced: function (dto) { return http.get("".concat(widgetSettingsUrl(dto.id), "/advanced")); },
        getCustomText: function (dto) { return http.get("".concat(widgetSettingsUrl(dto.id), "/advanced/").concat(dto.locale, "/texts")); },
        setCustomText: function (dto) {
            return http.put("".concat(widgetSettingsUrl(dto.id), "/advanced/").concat(dto.locale, "/texts"), { texts: dto.texts });
        },
        getCustomJs: function (dto) { return http.get("".concat(widgetSettingsUrl(dto.id), "/advanced/js")); },
        setCustomJs: function (dto) { return http.put("".concat(widgetSettingsUrl(dto.id), "/advanced/js"), { content: dto.content }); },
        getCustomCss: function (dto) { return http.get("".concat(widgetSettingsUrl(dto.id), "/advanced/css")); },
        setCustomCss: function (dto) { return http.put("".concat(widgetSettingsUrl(dto.id), "/advanced/css"), { content: dto.content }); },
        setAllowedDomains: function (dto) {
            return http.put("".concat(widgetSettingsUrl(dto.id), "/advanced/domains"), { domains: dto.domains });
        },
        setOpeningHours: function (dto) { return http.put("".concat(widgetContentUrl(dto.id, dto.locale), "/contacts/openingHours"), dto); },
        setAllContactsOpeningHours: function (dto) {
            return http.put("".concat(widgetContentUrl(dto.id, dto.locale), "/contacts/openingHours/all"), dto);
        },
        updateWidgetSchedule: function (dto) { return http.put("".concat(widgetContentUrl(dto.id, dto.locale), "/contacts/schedule"), dto); },
        setRequiredAuthenticationEnabled: function (dto) {
            return http.post("".concat(widgetSettingsUrl(dto.id), "/advanced/authenticationEnabled"), dto);
        },
        setContentSettings: function (dto) { return http.put("".concat(widgetContentUrl(dto.id, dto.locale)), dto); },
        setCallbackSettings: function (dto) { return http.put("".concat(phoneModuleUrl(dto.id, dto.locale)), dto); },
        setChatSettings: function (dto) { return http.put("".concat(widgetContentUrl(dto.id, dto.locale), "/contacts/channel/chat"), {
            settings: dto.settings
        }); },
        setContactFormSettings: function (dto) { return http.put("".concat(widgetContentUrl(dto.id, dto.locale), "/contacts/channel/form"), {
            settings: dto.settings
        }); },
        setSearchBarTitle: function (dto) {
            return http.put("".concat(widgetContentUrl(dto.id, dto.locale), "/modules/searchBar/title"), { title: dto.title });
        },
        setCategoriesListTitle: function (dto) {
            return http.put("".concat(widgetContentUrl(dto.id, dto.locale), "/modules/categories/title"), { title: dto.title });
        },
        setCustomHtmlModuleContent: function (dto) {
            return http.put("".concat(widgetContentUrl(dto.id, dto.locale), "/modules/html/").concat(dto.moduleId), dto);
        },
        setContentScope: function (dto) {
            return http.put("".concat(widgetContentUrl(dto.id, dto.locale), "/contentScope"), {
                contentScope: dto.contentScope, applyToAllLanguages: dto.applyToAllLanguages
            });
        },
        addModule: function (dto) {
            return http.post("".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules"), { moduleType: dto.moduleType });
        },
        removeModule: function (dto) {
            return http.delete("".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/").concat(dto.moduleId));
        },
        reorderModules: function (dto) {
            return http.put("".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/reorder"), dto);
        },
        enableChatModule: function (dto) {
            return http.post("".concat(chatModuleUrl(dto.id, dto.locale), "/enable"), { contactType: WidgetContactType.CHAT });
        },
        disableChatModule: function (dto) {
            return http.post("".concat(chatModuleUrl(dto.id, dto.locale), "/disable"), { contactType: WidgetContactType.CHAT });
        },
        enableContactFormModule: function (dto) {
            return http.post("".concat(contactFormModuleUrl(dto.id, dto.locale), "/enable"), { contactType: WidgetContactType.CONTACT_FORM });
        },
        disableContactFormModule: function (dto) {
            return http.post("".concat(contactFormModuleUrl(dto.id, dto.locale), "/disable"), { contactType: WidgetContactType.CONTACT_FORM });
        },
        enablePhoneModule: function (dto) {
            return http.post("".concat(phoneModuleUrl(dto.id, dto.locale), "/enable"), { contactType: WidgetContactType.CALLBACK });
        },
        disablePhoneModule: function (dto) {
            return http.post("".concat(phoneModuleUrl(dto.id, dto.locale), "/disable"), { contactType: WidgetContactType.CALLBACK });
        },
        enableLimitContactExposure: function (dto) {
            return http.post("".concat(widgetContentUrl(dto.id, dto.locale), "/contacts/exposure/enable"), dto);
        },
        disableLimitContactExposure: function (dto) {
            return http.post("".concat(widgetContentUrl(dto.id, dto.locale), "/contacts/exposure/disable"), dto);
        },
        setFeaturedArticleTitle: function (dto) {
            return http.put("".concat(featuredArticlesUrl(dto.id, dto.locale), "/title"), dto);
        },
        addFeaturedArticle: function (dto) {
            return http.post("".concat(featuredArticlesUrl(dto.id, dto.locale)), dto);
        },
        removeFeaturedArticle: function (dto) {
            // tslint:disable-next-line:max-line-length
            return http.delete("".concat(featuredArticlesUrl(dto.id, dto.locale), "?locale=").concat(dto.locale, "&id=").concat(dto.id, "&articleId=").concat(dto.articleId));
        },
        reorderFeaturedArticles: function (dto) {
            return http.post("".concat(featuredArticlesUrl(dto.id, dto.locale), "/reorder"), dto);
        },
        enableChatContacts: function (dto) {
            var locale = dto.locale;
            var localeParam = '';
            if (locale) {
                localeParam = "?locale=".concat(dto.locale);
            }
            return http.get("".concat(apiUrl, "/enabledChatContacts").concat(localeParam));
        },
        getTranslations: function (dto) {
            var answersOrigin;
            try {
                var origin_1 = new URL(baseUrl).origin;
                answersOrigin = origin_1;
            }
            catch (_a) {
                answersOrigin = '';
            }
            return http.get("".concat(answersOrigin, "/apps/widget/v1/translations/").concat(dto.locale));
        },
        chatbotPoc: createChatbotPocApi(baseUrl, http)
    };
};
//# sourceMappingURL=index.js.map